.links {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
}

@container press-release-root (min-width: 1024px) {
  .pressReleaseRoot {
    flex-direction: row;
    gap: 16px;
    align-items: start;
  }
}

@media screen and (width >= 1024px) {
  .screen {
    flex-direction: row;
    gap: 16px;
    align-items: start;
  }
}
